import Link from 'next/link';

import cn from '@/lib/clsxm';
import { eventTracker } from '@/lib/service-workers';

import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import Section from '@/components/app/product/components/@shared/section';
import Props from '@/components/app/product/components/store-card/type';
import { useGetProfile } from '@/components/layout/services/hooks';
import Medals from '@/components/shared/components/medals';

import { DATA_CY_STORE_CARD_PRODUCTS } from '@/constant/cypress';

export default function StoreCard({
  name,
  slogan = '',
  description = '',
  logo,
  medals = [],
  slug,
  className,
  id,
}: Props) {
  const { profile } = useGetProfile();
  const merchantEventHandler = () => {
    eventTracker(profile?.mobile, 'merchant_click', new Date().toISOString(), {
      vendor_name: name,
      vendor_id: id,
    });
  };

  const zhaketStore = process.env.NEXT_PUBLIC_ZHAKET_STORE?.split(',') || [];
  const targetHref = zhaketStore.includes(slug) ? '/' : `/store/web/${slug}/intro`;

  return (
    <Section
      id='developerMedals'
      data-cy={DATA_CY_STORE_CARD_PRODUCTS}
      className={cn(className, 'p-6! pb-8!')}
    >
      <Container center className='justify-between'>
        <Container onClick={merchantEventHandler}>
          <Link
            prefetch={false}
            href={targetHref}
            className='text-lg leading-8 font-bold text-[#424244]'
          >
            {name}
          </Link>
          <Text className='text-[13px] leading-6 text-[#76767C]'>{slogan}</Text>
        </Container>
        <XImage
          src={logo.publicLink}
          alt={logo.title}
          width={61}
          height={61}
          className='rounded-full border-2 border-[#FFFFFF] shadow-[0px_2px_8px_0px_#0000000D]'
        />
      </Container>
      <Text className='mt-[22px] mb-4 line-clamp-2 text-[13px] leading-[22px] text-[#5B5C60]'>
        {description}
      </Text>
      {medals.length > 0 && <Medals medals={medals} className='grid grid-cols-5' />}
    </Section>
  );
}
